export class HistoryEvent {
    public word: string;
    public wasCorrect: boolean;
    public index: number;

    constructor(word: string, wasCorrect: boolean, index: number) {
        this.word = word;
        this.wasCorrect = wasCorrect;
        this.index = index;
    }
}


// WEBPACK FOOTER //
// ./src/HistoryEvent.ts